module.exports = __webpack_public_path__ + "img/settings-dropdown.9074a5dd.svg";